import { useEffect, useState } from 'react';
import PollResult from '../../../components/task/components/PollResult'; // Adjust the import path based on your project structure
import axiosInstance from "../../../config/axios"; // Adjust the import path based on your project structure
import { clippingParents } from '@popperjs/core';
import { Console } from 'console';

interface Answer {
  id: string;
  participantsName: string;
  answerValue: string;
  isAnswer: boolean;
  answerCount: number;
}

interface Question {
  question: string;
  id: string;
  answer: Answer[];
  allowMultipleVoting: boolean;
  keepResponsesAnonymous: boolean;
}

interface Participant {
  submittedPoll: boolean;
}

interface ActivityData {
  title: string;
  description: string;
  duration: string;
  duration_in_days: string;
  submission_date: string;
  questions: Question[];
  participants: Participant[];
  status: string;
  submittedParticipants: number,
  totalParticipants: number,
  keepResponsesAnonymous: boolean,
  allowMultipleVoting: boolean,
}

function extractAllAnswerCount(data: any) {
  console.log("🚀 ~ extractAllAnswerCount ~ data:", data);

  const counts: any = {};

  data.forEach((entry: any) => {
    try {
      const answers = JSON.parse(entry.answers);

      answers[0].ans.forEach((questionData: any) => {
        const question = questionData.question;

        counts[question] = counts[question] || {};

        questionData.answer.forEach((answer: any) => {
          if (answer.isAnswer) {
            counts[question][answer.id] = (counts[question][answer.id] || 0) + 1;
          }
        });
      });
    } catch (error) {
      console.error("Error parsing answers in extractAllAnswerCount:", error);
    }
  });

  // Convert counts to a clean object without prototypes
  console.log("Cleaned counts:", JSON.parse(JSON.stringify(counts)));
  return JSON.parse(JSON.stringify(counts));
}


function extractParticipantWiseDetails(data: any) {
  const participantDetails: any = {};

  data.forEach((entry: any) => {
    const traineeId = entry.trainee_id;
    const answers = JSON.parse(entry.answers);

    answers.forEach((ans: any) => {
      const question: any = ans.ans[0].question;

      ans.ans[0].answer.forEach((answer: any) => {
        const isAnswerTrue = answer.isAnswer;

        if (isAnswerTrue) {
          if (!participantDetails[traineeId]) {
            participantDetails[traineeId] = [];
          }

          participantDetails[traineeId].push({
            question: question,
            answerId: answer.id
          });
        }
      });
    });
  });

  return participantDetails;
}


function mapQuestions(traineeSubmittedTask: any, isAnswerCounts: any, participantDetails: any) {
  const answers: any = isAnswerCounts ? Object.values(isAnswerCounts)[0] : [];
  const questionText = Object.keys(isAnswerCounts)[0];

  if (!traineeSubmittedTask || !traineeSubmittedTask.answers) {
    return [];
  }

  const parsedAnswers = JSON.parse(traineeSubmittedTask.answers);

  if (!parsedAnswers || !parsedAnswers.length) {
    console.log("Coming here means (!parsedAnswers || !parsedAnswers.length) ")
    return [];
  }

  let id = 1;
  console.log("parsedAnswers[0].ans[0].id =", parsedAnswers[0].ans[0].id)
  console.log("parsedAnswers[0].ans[0].answer =", parsedAnswers[0].ans[0].answer)
  const questionId = id;

  return parsedAnswers[0].ans[0].answer.map((question: any) => {

    let count;
    if (question.allowMultipleVoting) {
      count = answers[questionId];
      console.log("count is coming inside (question.allowMultipleVoting) : ", count);
    } else {
      const uniqueTrainees = new Set(participantDetails.map((entry: any) => entry.trainee_id));
      count = uniqueTrainees.size;
      console.log("count is coming like this here :", count)
    }

    return {
      question: question.question || '',
      id: id++ || '',
      answer: question.answer.map((answer: any) => {
        const answerId = answer.id;

        return {
          id: answerId,
          participantsName: answer.participantsName || '',
          answerValue: answer.answerValue || '',
          isAnswer: answer.isAnswer || false,
          answerCount: count || 0,
        };
      }),
      allowMultipleVoting: question.allowMultipleVoting || false,
      keepResponsesAnonymous: question.keepResponsesAnonymous || false
    };
  });
}


function mapQuestionsNew(traineeSubmittedTask: any, isAnswerCounts: any = {}): Question[] {
  console.log("traineeSubmittedTask:", traineeSubmittedTask);
  if (!traineeSubmittedTask || !traineeSubmittedTask.answers) {
    return [];
  }

  try {
    const answers = JSON.parse(traineeSubmittedTask.answers);
    console.log("answers:", answers);

    if (!answers || !Array.isArray(answers) || !answers.length || !answers[0].ans) {
      console.log("No valid answers array or ans property");
      return [];
    }

    return answers[0].ans.map((questionData: any, index: number) => {
      const questionId = questionData?.id || `q${index + 1}`;
      const questionText = questionData?.question || '';

      return {
        question: questionText,
        id: questionId,
        answer: questionData?.answer.map((ans: any) => ({
          id: ans.id || '',
          participantsName: ans.participantsName || '',
          answerValue: ans.answerValue || '',
          isAnswer: ans.isAnswer || false,
          answerCount: isAnswerCounts[questionText]?.[ans.id] || 0, // Use aggregated count
        })) || [],
        allowMultipleVoting: questionData?.allowMultipleVoting || false,
        keepResponsesAnonymous: questionData?.keepResponsesAnonymous || false,
      };
    });
  } catch (error) {
    console.error("Error parsing answers in mapQuestionsNew:", error);
    return [];
  }
}

function mapParticipants(apiData: any): Participant[] {
  if (!apiData || !apiData.ActivityData) {
    return [];
  }

  return apiData.ActivityData.map((participant: any) => ({
    submittedPoll: participant.activitySubmissionStatus.toLowerCase() === 'submitted',
  }));
}

function usePollResultData(sessionSegmentId: any) {
  const [activityData, setActivityData] = useState<ActivityData>({
    title: '',
    description: '',
    duration: '',
    duration_in_days: '',
    submission_date: '',
    status: '',
    questions: [],
    participants: [],
    submittedParticipants: 0,
    totalParticipants: 0,
    keepResponsesAnonymous: false,
    allowMultipleVoting: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post("/programme/view_activity_status", {
          sessionSegmentId: sessionSegmentId,
        });
        // console.log('Full API Response:', JSON.stringify(response.data, null, 2));

        const submittedUser = response?.data?.ActivityData
          ? response.data.ActivityData.filter((el: any) => el?.activitySubmissionStatus.toLowerCase() === 'submitted')
          : [];
        console.log('submittedUser:', submittedUser);

        const apiData = response?.data?.ActivityData?.[0] || {};
        console.log('API Data:', apiData);

        const submissionResponse = await axiosInstance.get(`/trainer/get_trainee_submitted_task?session_segment_id=${sessionSegmentId}`);
        console.log('Submission Response:', submissionResponse);

        const submissionApiData = submissionResponse?.data || [];
        console.log('Submission API Data:', submissionApiData);

        const totalParticipants = response?.data?.ActivityData?.length || 0;
        const submittedParticipants = submittedUser.length;
        console.log('totalParticipants:', totalParticipants, 'submittedParticipants:', submittedParticipants);

        const isAnswerCounts = extractAllAnswerCount(submissionApiData);
        console.log('Is Answer Counts:', isAnswerCounts);

        const participantDetails = extractParticipantWiseDetails(submissionApiData);
        console.log('participantDetails:', participantDetails);

        // Extract keepResponsesAnonymous and allowMultipleVoting from answers
        let keepResponsesAnonymous = false;
        let allowMultipleVoting = false;
        if (submittedUser[0]?.answers) {
          try {
            const answers = JSON.parse(submittedUser[0].answers);
            if (answers?.[0]?.ans?.[0]) {
              keepResponsesAnonymous = answers[0].ans[0].keepResponsesAnonymous || false;
              allowMultipleVoting = answers[0].ans[0].allowMultipleVoting || false;
            }
          } catch (error) {
            console.error('Error parsing answers for flags:', error);
          }
        }

        setActivityData({
          title: apiData.activityTitle || '',
          description: '',
          duration: '',
          duration_in_days: '',
          submission_date: apiData.created_on || '',
          status: submissionApiData[0]?.ongoing ? 'Live' : 'Closed',
          questions: mapQuestionsNew(submittedUser[0] || {}, isAnswerCounts),
          participants: mapParticipants(response?.data?.data || {}),
          totalParticipants: totalParticipants,
          submittedParticipants: submittedParticipants,
          keepResponsesAnonymous,
          allowMultipleVoting,
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [sessionSegmentId]);

  return activityData;
}

const PollResultBySesId = ({ sessionSegmentId }: any) => {
  const activityData = usePollResultData(sessionSegmentId);

  return (
    <div>
      <PollResult activityData={activityData} />
    </div>
  );
};

export default PollResultBySesId;